import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Box,
  Typography,
  IconButton,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import { closePreview, selectContentPreview } from "@/store/slices/contentPreviewSlice";
import { RichTextDisplay } from "@/components/common";

const ContentPreviewDialog = () => {
  const dispatch = useDispatch();
  const { isOpen, type, content } = useSelector(selectContentPreview);

  const handleClose = () => {
    dispatch(closePreview());
  };

  return (
    <Dialog open={isOpen} onClose={handleClose} maxWidth="md" fullWidth>
      <DialogTitle>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography variant="h6">
            {type === "image" ? "Image Preview" : "Content Preview"}
          </Typography>
          <IconButton onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Box display="flex" justifyContent="center" p={2}>
          {type === "image" && content && (
            <img
              src={content}
              alt="Preview"
              style={{
                maxWidth: "100%",
                maxHeight: "70vh",
                objectFit: "contain",
              }}
            />
          )}
          {type === "richtext" && content && (
            <Box
              style={{
                maxWidth: "100%",
                maxHeight: "70vh",
                overflow: "auto",
              }}
            >
              <RichTextDisplay content={content} />
            </Box>
          )}
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ContentPreviewDialog;
